module.exports = __webpack_public_path__ + "static/media/temis.2dca6695.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/temis.png
// module id = 139
// module chunks = 0